module.exports = "<p>\r\n  user-details works!\r\n</p>\r\n"